import React from "react";

import ResultsTableView from "./results-table-view";

export default ({ age, startingCapital, monthlyDeposit, riskToleranceMod }) => {
  let months = [];
  let lastBalance;
  for (let month = 1; month <= 240; month++) {
    const capital = lastBalance === undefined ? startingCapital : lastBalance;

    let profitPercentage;
    if (capital < 3000) {
      profitPercentage = 0.01;
    } else if (capital < 10_000) {
      profitPercentage = 0.02;
    } else if (capital < 150_000) {
      profitPercentage = 0.021;
    } else if (capital < 1_000_000) {
      profitPercentage = 0.015;
    } else {
      profitPercentage = 0.01;
    }
    profitPercentage += riskToleranceMod;

    const profit = capital * profitPercentage;

    const balance = capital + profit + monthlyDeposit;
    lastBalance = balance;

    months.push({
      month,
      capital,
      profitPercentage,
      profit,
      balance,
    });
  }

  return <ResultsTableView age={age} months={months} />;
};
